import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { displayDateTime } from 'reducers/TimeReducer';
import { handleError } from 'reducers/ErrorReducer';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from 'components/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { showReport } from 'reducers/DialogsReducer';
import QuickFilterSearch from '../components/QuickFilterSearch';
import { searchAgencies } from 'reducers/SearchReducer';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/Check';
import XGrid3 from 'components/XGrid3';
import { useSelector } from 'react-redux';
import NoPermissionRedirect from 'components/NoPermissionRedirect';
import LocalPrintshopRoundedIcon from '@material-ui/icons/LocalPrintshopRounded';
import { getAgenciesFullPermission } from 'reducers/PermissionsReducer';
import { getFullPermissions } from 'reducers/PermissionsReducer';
import { checkReportPermission } from 'utils/functions';

const useStyles = makeStyles((theme) => ({
  filters: {
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
    '& > div': {
      marginRight: theme.spacing(2),
    },
  },
  gridWrap: {
    width: '100%',
    boxSizing: 'border-box',
    height: 600,
  },
  filterWrap: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  filter: {
    width: '100%',
    marginBottom: '8px',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
  },
  panel: {
    '& .MuiDataGridPanelFooter-root': {
      display: 'none',
    },
  },
}));

const bool = (params) => (params.value ? <CheckIcon /> : <span></span>);

const defaultColumns = [
  { field: 'AgencyID', headerName: 'Agency ID', width: 150, hide: false },
  { field: 'Description', headerName: 'Description', width: 150, hide: false },
  { field: 'AgencyImage', headerName: 'Agency Image', width: 150, hide: false },
  { field: 'PlaceID', headerName: 'Place ID', width: 150, hide: false },
  { field: 'PlaceName', headerName: 'Place Name', width: 150, hide: false },
  { field: 'Police', headerName: 'Police', width: 150, hide: false },
  { field: 'Fire', headerName: 'Fire', width: 150, hide: false },
  { field: 'EMS', headerName: 'EMS', width: 150, hide: false },
  {
    field: 'IsDeleted',
    headerName: 'Is Deleted',
    width: 100,
    format: 'bool',
    renderCell: bool,
    hide: false,
  },
  {
    field: 'Deleted',
    headerName: 'Deleted',
    width: 120,
    valueFormatter: (params) => displayDateTime(params.value),
    format: 'date',
    hide: false,
  },
  { field: 'DeletedBy', headerName: 'Deleted By', width: 150, hide: false },
  { field: 'DeletedID', headerName: 'Deleted ID', width: 140, hide: false },
];

function Agency(props) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selection, setSelection] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [agencyColumns, setAgencyColumns] = useState(defaultColumns);
  const [printFlag, setPrintFlag] = useState(false);
  const canReadAgencies = getAgenciesFullPermission('globals', 'Zones', 'Read');
  const Agencies = useSelector((state) => state.dictionary.Agencies);
  const permissions = getFullPermissions('globals', 'Agencies', 'any');
  useEffect(() => {
    if (permissions.Read) {
      getAgencyData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAgencyData = async () => {
    setLoaded(false);
    const agencyList = canReadAgencies.filter((AgencyID) =>
      Agencies.find((agency) => agency.AgencyID === AgencyID)
    );
    searchAgencies(!agencyList || agencyList.length === 0 ? null : agencyList)
      .then((result) => setRows(processData(result)))
      .catch(props.handleError)
      .finally(() => setLoaded(true));
  };
  if (!permissions.Read) return <NoPermissionRedirect />;

  const processData = (data) => {
    return data.map((row) => {
      return {
        ...row,
        id: row.AgencyID,
      };
    });
  };

  const viewDetails = () => {
    let item = filteredRows.find((row) => row.id === selection);
    if (!item || !checkReportPermission(29)) return;
    props.showReport({ id: 29, data: { AgencyID: item.AgencyID }, title: 'Agency Details' });
  };

  const handlePrintClick = () => {
    setPrintFlag(true);
    setTimeout(() => setPrintFlag(false), 1000);
  };

  if (!canReadAgencies.length) return <NoPermissionRedirect />;
  return (
    <div>
      <h5>Agencies</h5>
      <div className={classes.filterWrap}>
        <div className={classes.filterWrap}>
          <QuickFilterSearch
            rows={rows}
            columns={agencyColumns}
            setFilteredRows={setFilteredRows}
          />
        </div>
        <div className={classes.actions}>
          <Tooltip title="Print list">
            <Fab size="small" color="secondary" onClick={handlePrintClick}>
              <LocalPrintshopRoundedIcon />
            </Fab>
          </Tooltip>
          {selection !== null && (
            <Tooltip title="View details">
              <Fab
                className="ml-2"
                size="small"
                color="secondary"
                disabled={!checkReportPermission(29)}
                onClick={viewDetails}>
                <InfoIcon />
              </Fab>
            </Tooltip>
          )}
        </div>
      </div>
      <XGrid3
        name="Agencies"
        columns={agencyColumns}
        setColumns={setAgencyColumns}
        rows={filteredRows}
        loading={!loaded}
        setSelection={setSelection}
        printFlag={printFlag}
        viewDetails={viewDetails}
        refresh={getAgencyData}
      />
    </div>
  );
}

export default connect(null, {
  handleError,
  showReport,
})(Agency);
